module.exports = __webpack_public_path__ + "static/media/400387_01.2e68bbb6.png";